import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate(['GROUP_AVATARS_LOADED']);

export const AvatarImages = {
  ORG_AVATAR: require('assets/images/school-circle.svg'),
  URGENT_AVATAR: require('assets/images/SplitComposer/urgent.svg'),
};
